import styled from 'styled-components';
import { colors } from '../Colors';
import { Severity } from '../types/severity';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const Title = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #232323;
`;

export const InnerBox = styled.div<{ $type: Severity }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 16px;
    border-radius: 10px;
    background-color: ${({ $type }) => $type && colors[$type] ? `${colors[$type]}33` : 'transparent'};
`;

export const Label = styled.p`
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: #323232;
`;

export const Value = styled.p<{ $type: Severity }>`
    margin: 0;
    font-size: 28px;
    font-weight: 700;
    color: ${({ $type }) => $type && colors[$type] ? colors[$type] : '#323232'};
`;

export const Subtitle = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #6b6b6b;
`;